window.addEventListener('DOMContentLoaded', function(event){

    const contactFooter = document.querySelector('.footer__contact')

    const contactBtn = document.querySelector('.stickyContact')

    var intersectionObserver = new IntersectionObserver(function(entries) {
        const [{ isIntersecting }] = entries;

        if (isIntersecting) {

            contactBtn.classList.add('hidden')
            
        } else {

            contactBtn.classList.remove('hidden')

        }

    });
    intersectionObserver.observe(contactFooter);

    const togglers = document.querySelectorAll('.footer__nav > ul > li > ul > .menu-item-has-children')

    togglers.forEach((toggler) => {
        toggler.querySelector('.subMenuToggler').addEventListener('click', () => {
            toggler.classList.toggle('active')
        })
    })

})